export default "6 opérations BAT-* mobilisables sur votre patrimoine tertiaire ≥ 1 000 m² : PAC (BAT-TH-104), GTB (BAT-TH-116), ECS solaire (BAT-TH-152), isolation, relamping LED, calorifugeage.";
